import {
   AwsIcon,
   DockerIcon,
   GithubIcon,
   MongodbIcon,
   MysqlIcon,
   NodeIcon,
   ReactIcon,
   RedisIcon,
   SpringBootIcon,
   VueIcon,
} from "../../components/portfolio/skills/skillIcons";

const SKILLS = [
   {
      id: "node",
      name: "Node.js",
      description:
         "JavaScript runtime for building fast & scalable server-side applications.",
      Icon: NodeIcon,
   },
   {
      id: "react",
      name: "React",
      description:
         "A JavaScript library for building interactive and dynamic user interfaces.",
      Icon: ReactIcon,
   },
   {
      id: "aws",
      name: "AWS",
      description:
         "Cloud platform for scalable, secure and high-performance applications.",
      Icon: AwsIcon,
   },
   {
      id: "vue",
      name: "Vue.js",
      description:
         "Progressive JavaScript framework for building modern web applications.",
      Icon: VueIcon,
   },
   {
      id: "github",
      name: "GitHub",
      description:
         "Version control and collaboration for modern development teams.",
      Icon: GithubIcon,
   },
   {
      id: "docker",
      name: "Docker",
      description:
         "Containerization tool for consistent and efficient development workflows.",
      Icon: DockerIcon,
   },
   {
      id: "mysql",
      name: "MySQL",
      description:
         "Relational database for structured data, transactions, and reliable persistence.",
      Icon: MysqlIcon,
   },
   {
      id: "redis",
      name: "Redis",
      description:
         "In-memory data store for caching, sessions, and high-speed lookups.",
      Icon: RedisIcon,
   },
   {
      id: "mongodb",
      name: "MongoDB",
      description:
         "NoSQL database for flexible documents and scalable application data.",
      Icon: MongodbIcon,
   },
   {
      id: "springboot",
      name: "Spring Boot",
      description:
         "Java framework for building production-ready APIs and microservices.",
      Icon: SpringBootIcon,
   },
];

function SkillSparkle({ className = "" }) {
   return (
      <svg
         className={className}
         viewBox="0 0 24 24"
         xmlns="http://www.w3.org/2000/svg"
         aria-hidden="true"
      >
         <path
            d="M12 2l2.2 5L19 9l-5 2.2L12 16l-2.2-4.8L5 9l4.8-2L12 2z"
            fill="currentColor"
         />
      </svg>
   );
}

function Skills() {
   return (
      <section id="skill-section" className="skills-section">
         <span className="skills-decor skills-decor--tl" aria-hidden="true" />
         <span className="skills-decor skills-decor--tr" aria-hidden="true" />

         <header className="skills-header">
            <div className="skills-title-row">
               <span className="skills-sparkle skills-sparkle--left" aria-hidden="true">
                  <SkillSparkle />
               </span>
               <h1 className="skills-title">
                  Technical <span className="skills-title-accent">Skills</span>
               </h1>
               <span className="skills-sparkle skills-sparkle--right" aria-hidden="true">
                  <SkillSparkle />
               </span>
            </div>

            <p className="skills-subtitle">
               Technologies and tools I use to build intelligent, scalable and{" "}
               <span className="skills-subtitle-highlight">impactful</span>{" "}
                           applications.
            </p>
            <span className="skills-accent-bar" aria-hidden="true" />
         </header>

         <div className="skills-grid">
            {SKILLS.map(({ id, name, description, Icon }) => (
               <article key={id} className={`skill-card skill-card--${id}`}>
                  <span className="skill-card-glow" aria-hidden="true" />
                  <div className="skill-card-icon" aria-hidden="true">
                     <Icon />
                  </div>
                  <h3 className="skill-card-name">{name}</h3>
                  <p className="skill-card-desc">{description}</p>
                  <span className="skill-card-accent" aria-hidden="true" />
               </article>
            ))}
            </div>
         </section>
   );
}

export default Skills;
